import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { isValidLinkedAccount } from '../../entities/LinkedAccount';
import { BaseClient } from '../BaseClient';
export class LinkedAccountClientBase extends BaseClient {
  constructor() {
    super(...arguments);
    _defineProperty(this, "listLinkedAccountsImpl", void 0);
  }
  async listLinkedAccounts() {
    try {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      const {
        linkedAccounts
      } = await this.request(this.listLinkedAccountsImpl({}), ...args);
      if (!linkedAccounts) {
        throw new Error('linked accounts is not an array');
      }
      return linkedAccounts.map(this.convertToEntity);
    } catch (error) {
      this.logError('listLinkedAccounts', 'Failed to list linked accounts', {}, error);
      throw error;
    }
  }
  convertToEntity(linkedAccount) {
    try {
      if (!linkedAccount) {
        throw new Error('Invalid linkedAccount', {
          cause: {
            linkedAccount
          }
        });
      }
      const {
        appleCalendar = {},
        googleCalendar = {},
        outlookCalendar = {},
        wixBookings = {}
      } = linkedAccount.accountProvider || {};
      const convertedLinkedAccount = {
        id: linkedAccount.id,
        email: linkedAccount.identifier,
        ...appleCalendar,
        ...googleCalendar,
        ...outlookCalendar,
        ...wixBookings,
        guidelines: linkedAccount.guidelines
      };
      if (isValidLinkedAccount(convertedLinkedAccount)) {
        return convertedLinkedAccount;
      }
      throw new Error('Invalid linkedAccount data', {
        cause: {
          linkedAccount
        }
      });
    } catch (error) {
      this.logError('convertToEntity', 'Failed to convert linkedAccount', {
        linkedAccount
      }, error);
      throw error;
    }
  }
  getServiceNameForLogs() {
    return 'LinkedAccountClient';
  }
}
//# sourceMappingURL=LinkedAccountClientBase.js.map